module.exports = __webpack_public_path__ + "img/consult_info1.3877d463.png";